import React, { memo, useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './Update.module.less';

import { PCStoreJsBridge } from '../../../nativeapi';
import { logging } from '../../../actions/log';
import Toast from '../../../components/Toast/Toast';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  // 是否打开自动升级商店
  const [isEnabledAutoUpdate, setIsEnabledAutoUpdate] = useState(true);

  useEffect(() => {
    // 是否可自动升级商店，自动升级商店是否打开
    PCStoreJsBridge.getUpdatePCStoreState().then(res => {
      if (res) {
        setIsEnabledAutoUpdate(!!res.userQuietUpgrade);
      }
    });
  }, []);

  // 自动升级设置
  const handleCheckAutoUpdate = useCallback(enabled => {
    setIsEnabledAutoUpdate(!enabled);
    // 保存自动更新商店设置
    PCStoreJsBridge.setUpdatePCStoreState({ userQuietUpgrade: !enabled });
    Toast.success({
      content: '设置成功!',
    });

    // 点击 切换打开升级设置
    dispatch(
      logging({
        category: 'C',
        action: 'AutoUpdate_Cancel',
        label: '',
        param2: {
          source: 'Setting',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          enabled: !enabled,
        },
      }),
    );
  }, []);
  return (
    <div className={styles.s_update}>
      <div className="s_line">
        <div className="s_select_title">升级设置:</div>
        <div className="s_content">
          <div className="checkbox" onClick={() => handleCheckAutoUpdate(isEnabledAutoUpdate)}>
            {isEnabledAutoUpdate ? <div className="checked" /> : <div className="no_checked" />}
            <span>有更新时自动升级联想应用商店</span>
          </div>
          <div className="desc">
            推荐开启自动升级，更早体验联想应用商店最新版本，享受极致使用体验
          </div>
        </div>
      </div>
    </div>
  );
});
